(function () {
  function initSlider(slot) {
    if (slot.dataset.mgInit === '1') return;
    slot.dataset.mgInit = '1';

    var slides = slot.querySelectorAll('.mg-slide');
    if (slides.length <= 1) return;

    var dotsBox = slot.querySelector('[data-dots]');

    // ✅ 每個 tile 獨立讀取速度（優先 .mg-tile，fallback .mg）
    var tile = slot.closest('.mg-tile');
    var container = slot.closest('.mg');

    var interval = 3500;
    var transition = 500;

    function readAttr(el, name) {
      return el && el.getAttribute(name) ? el.getAttribute(name) : null;
    }

    var aVal = readAttr(tile, 'data-autoplay') || readAttr(container, 'data-autoplay');
    var tVal = readAttr(tile, 'data-transition') || readAttr(container, 'data-transition');

    if (aVal) interval = parseInt(aVal, 10) || 3500;
    if (tVal) {
      transition = parseInt(tVal, 10) || 500;
      slot.style.setProperty('--mg-transition', transition + 'ms');
    }

    var current = 0;
    var timer = null;

    if (dotsBox) {
      dotsBox.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        (function (idx) {
          var d = document.createElement('span');
          if (idx === 0) d.classList.add('is-active');
          d.addEventListener('click', function () {
            go(idx);
            restart();
          });
          dotsBox.appendChild(d);
        })(i);
      }
    }

    function go(i) {
      current = ((i % slides.length) + slides.length) % slides.length;
      for (var idx = 0; idx < slides.length; idx++) {
        var s = slides[idx];
        var isActive = idx === current;
        s.classList.toggle('is-active', isActive);
        var v = s.querySelector('video');
        if (v) {
          if (isActive) {
            try { v.currentTime = 0; } catch (e) {}
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        }
      }
      if (dotsBox) {
        var dots = dotsBox.children;
        for (var k = 0; k < dots.length; k++) {
          dots[k].classList.toggle('is-active', k === current);
        }
      }
    }

    function next() { go(current + 1); }
    function start() { stop(); timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    slot.addEventListener('mouseenter', stop);
    slot.addEventListener('mouseleave', start);

    go(0);
    start();
  }

  function initAll() {
    var nodes = document.querySelectorAll('.mg-slot[data-slider="true"]');
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();